<template lang="pug"></template>

<script>
export default {
    name: 'BotaoRepresentante',
    componentOptions: {
        title: 'Pessoa',
        actions: [
            [
                {
                    name: 'Pessoa',
                    iconClass: 'lyra-icon lyra-user',
                    showView: false,
                    action: 'abrirRepresentante',
                    route: 'Pessoa'
                }
            ]
        ]
    },

    methods: {
        abrirRepresentante() {
            if (this.$route.name !== 'Pessoa') {
                this.$router.push({ name: 'Pessoa' });
            } else {
                this.$router.go();
            }
        }
    }
};
</script>
